import { useEffect } from 'react';

/**
 * Adds the class `classname` to `element` and removes it on dismount.
 * Behavior is undefined if anything else adds or removes the same classname to
 * the same element.
 */
export function useClassname(classname: string, element: Element) {
  useEffect(() => {
    element.classList.add(classname);
    return () => {
      element.classList.remove(classname);
    };
  }, [element, classname]);
}
export default useClassname;
